// ============================================
// Modal.js
// MicroModal を使ったモーダルウィンドウ
//
// 使用ライブラリ:
//   MicroModal : https://micromodal.vercel.app/
//
// 機能:
//   - .js-modal クラスを持つ要素に対してモーダルを初期化する
//   - Lenis のスクロールロックと連動させる場合は下記コメントを参照
//
// ============================================
// HTML 構造例:
// ============================================
//
// <!-- トリガーボタン -->
// <button
//   type="button"
//   data-micromodal-trigger="modal-sample"
//   aria-haspopup="dialog"
// >モーダルを開く</button>
//
// <!-- モーダル本体 -->
// <!-- id は data-micromodal-trigger の値と一致させる -->
// <div id="modal-sample" class="js-modal" aria-hidden="true">
//   <div class="js-modal__overlay" tabindex="-1" data-micromodal-close>
//     <div
//       class="js-modal__container"
//       role="dialog"
//       aria-modal="true"
//       aria-labelledby="modal-sample-title"
//     >
//       <header class="js-modal__header">
//         <h2 id="modal-sample-title">モーダルタイトル</h2>
//         <button
//           type="button"
//           class="js-modal__close"
//           aria-label="閉じる"
//           data-micromodal-close
//         ></button>
//       </header>
//       <div class="js-modal__content">
//         <p>モーダルの内容をここに記述する。</p>
//       </div>
//     </div>
//   </div>
// </div>
//
// ※ 複数のモーダルを設置する場合は id を変えて同じ構造を繰り返す。
// ============================================

import MicroModal from 'micromodal';

// ============================================
// 設定値
// ============================================
const CONFIG = {
  // モーダルコンテナのセレクター（このクラスを持つ要素を対象にする）
  modalSelector: '.js-modal',

  // モーダル内のスクロールイベントが背景に伝播しないようにするか
  // Lenis を使用している場合は true にすることを推奨する
  preventScrollPropagation: true,
};

// ============================================
// modal — モーダルを初期化する
//
// MicroModal.init() は data-micromodal-trigger 属性を持つ要素を
// 自動的に検出してクリックイベントを登録する。
//
// Lenis との連携:
//   Lenis を使っている場合、MicroModal の disableScroll オプションより
//   lenis.stop() / lenis.start() を使う方がスクロールを確実に制御できる。
//   その場合は onShow / onClose コールバックに lenis の制御を追加する。
//
//   import { lenis } from './Scroll';
//   MicroModal.init({
//     onShow: () => lenis.stop(),
//     onClose: () => lenis.start(),
//   });
// ============================================
function modal() {
  const modals = document.querySelectorAll(CONFIG.modalSelector);
  if (modals.length === 0) return;

  MicroModal.init({
    // aria-hidden の変更によって CSS でモーダルの表示/非表示を切り替える場合は
    // disableScroll は false にして CSS 側で overflow: hidden を制御する方法もある
    disableScroll: true,
  });

  // モーダル内のスクロールが Lenis（背景）に伝わるのを防ぐ
  // wheel / touchmove を stopPropagation で止めることで、
  // モーダル内のスクロールが背景スクロールをトリガーしなくなる
  if (CONFIG.preventScrollPropagation) {
    modals.forEach((modalEl) => {
      // バインド済みチェック（二重登録防止）
      if (modalEl.dataset.modalScrollBound === '1') return;
      modalEl.dataset.modalScrollBound = '1';

      modalEl.addEventListener('wheel', (e) => {
        e.stopPropagation();
      });

      modalEl.addEventListener('touchmove', (e) => {
        e.stopPropagation();
      });
    });
  }
}

export { modal };
